import { type ReactElement } from 'react';
import { Mark } from './brand';

/**
 * The cold-load screen of every console, shown while the session is being restored (V-LIB-SHELL, D509; audit consoles F08
 * + admin #2). Three apps shouted "CARREGANDO" in caps at 0.12em, two of them without a live region, and the PDV built
 * its own. This one is sentence case in the `label` role, announced politely (`role="status"`), carries the Vello mark,
 * and fades in after a short delay (`--boot-splash-delay`) so a boot that finishes at once never flashes it. Under
 * reduced motion the theme's global block makes the fade instant.
 *
 *   if (!booted) return <BootSplash label={t('chrome.loading')} />;
 */
export function BootSplash({ label }: { label: string }): ReactElement {
  return (
    <main className="vello-boot-splash">
      <div className="vello-boot-splash__body" role="status">
        <Mark size={40} title="" />
        <p className="vello-boot-splash__label">{label}</p>
      </div>
    </main>
  );
}
